import Tagline from './Tagline';
import KeyServices from './KeyServices';
import Clients from './Clients';
import Carousel from './Carousel';
import Portfolio from './Portfolio';
import Blog from './Blog';
import Testimonials from './Testimonials';
import { useTranslation } from 'react-i18next';
import Hero from '../../components/hero/Hero';
import { ICallToAction } from '../../components/hero/IHeroProps';
import SEO from '../../app/SEO';

const Home = () => {
	const { t } = useTranslation("home");

	const ctoa: ICallToAction = {
		text: t("hero.callToAction"),
		url: "/contact"
	};

  	return (
    	<div>

			<SEO />

			<Hero
				title={t("hero.title")}
				subtitle={t("hero.description")}
				cta={ctoa}
				videoUri="/video/top-banner-video-h264.mp4"
				videoPreviewUri='/video/top-banner-video-preview.webp'
				/>
			<Tagline />
			<KeyServices />
			<Clients />
			<Carousel />
			<Portfolio />
			<Blog />
			<Testimonials />

		</div >
  	);
}

export default Home;